// src/components/icons/createCustomIcon.tsx
import React from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';

// import Styled from './custom-styled-icon';

/**
 * Drop-in replacement for createSvgIcon that avoids MUI barrel circular deps.
 * 
 * @example
 * export const ArrowCircleDown = createCustomIcon(
 *   <>
 *     <path d="..." stroke="currentColor" strokeWidth="1.2" />
 *   </>,
 *   'ArrowCircleDown',
 *   '0 0 16 16'
 * );
 */
export function createCustomIcon(
  children: React.ReactNode,
  displayName: string,
  viewBox = '0 0 24 24'
) {
  const BaseIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(
    function CustomIcon(props, ref) {
      return (
        <SvgIcon
          ref={ref}
          viewBox={viewBox}
          data-testid={`${displayName}Icon`}
          inheritViewBox={false}
          {...props}
        >
          {children}
        </SvgIcon>
      );
    }
  );

  BaseIcon.displayName = displayName;
  (BaseIcon as any).muiName = 'SvgIcon';

  return BaseIcon as typeof SvgIcon;
}